import React from 'react';
import RoleBasedNavigation from '../ui/RoleBasedNavigation';
import NotificationCenter from '../ui/NotificationCenter';
import UserRoleIndicator from '../ui/UserRoleIndicator';
import BreadcrumbNavigation from '../ui/BreadcrumbNavigation';
import { useAuth } from '../../contexts/AuthContext';

const MainLayout = ({ 
  children, 
  showBreadcrumbs = true,
  customBreadcrumbs = null
}) => {
  const { userProfile } = useAuth();

  const userRole = userProfile?.role || 'contractor';
  const userName = userProfile?.full_name || 'User';

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <div className="fixed top-0 left-0 right-0 h-16 z-[1000]" style={{ background: 'rgba(10,10,10,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #1A1A1A' }}>
        <div className="h-full px-4 lg:px-6 flex items-center justify-between">
          <RoleBasedNavigation userRole={userRole} />
          
          <div className="flex items-center gap-2">
            <NotificationCenter userRole={userRole} />
            <UserRoleIndicator userRole={userRole} userName={userName} />
          </div>
        </div>
      </div>

      <main className="pt-16">
        <div className="container mx-auto px-4 lg:px-6 py-6 lg:py-8">
          {showBreadcrumbs && <BreadcrumbNavigation customBreadcrumbs={customBreadcrumbs} />}
          {children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;